import { Outlet } from 'react-router-dom';

import Text from '~components/dumbs/Text';
import DeviceProblem from '~components/svgs/DeviceProblem';

import * as Styled from './styled';

function ChromeOnIOSGuard() {
  if (window.navigator.userAgent.match('CriOS')) {
    return (
      <Styled.Container>
        <Styled.IllustrationWrapper>
          <DeviceProblem />
        </Styled.IllustrationWrapper>
        <Text variant="h800" color="neutral-strong">
          Ops! Navegador Google Chrome não suportado
        </Text>
        <Text>Recomendamos que utilize o navegador Safari no seu Iphone.</Text>
      </Styled.Container>
    );
  }

  return <Outlet />;
}

export default ChromeOnIOSGuard;
